export default __webpack_public_path__ + "static/23-941164da7a3020cf12ec55e2c0869d12.png";